import React, {useEffect, useState} from 'react';
import FileService from "../service/FileService";

const Lacks = ({estimates, coeffs}) => {
    const [l, setL] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function loadLacks() {
            const res = await FileService.readFile("lacks", {estimates, coeffs});
            setL(res.data);
            setLoading(false);
        }
        loadLacks();
    }, [estimates, coeffs]);
    if (loading) return <p className="no-estimatesBlock">Загрузка...</p>

    return (
        <ul>
            {l !== 0 ? Object.keys(l).filter((a) => Number(a)).reverse().map(key => {
                const value = l[key];
                return <li key={key}><span className={value.color}>до {key}</span>:
                    {Object.values(value).sort(() => -1).map(value2 => {
                        if (value2.lack === undefined || value2.word === undefined) return "";
                        return <span key={value2.word}> <span style={{fontFamily: "Source_Sans3_bold, sans-serif"}}>{value2.lack}</span> {value2.word};</span>
                    })}
                </li>
            }) : <p className="no-estimatesBlock">нет оценок</p>}
        </ul>
    );
};

export default Lacks;